import { render, staticRenderFns } from "./VariantProductListingSection.vue?vue&type=template&id=2c3554f9&scoped=true&"
import script from "./VariantProductListingSection.vue?vue&type=script&lang=js&"
export * from "./VariantProductListingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3554f9",
  null
  
)

export default component.exports